import { CallHistoryMethodAction, push } from 'connected-react-router';
import { ApplicationState, NEiTThunk, routes } from '..';
import { Matricola, TipoIntervento } from '../core-assistenza';
import notification from '../notification';
import { ChiamateActions } from './actionTypes';
import * as chiamateApi from './api';
import { ChiamataNew, StatoFiltroChiamate } from './models';

type Actions = 
    ChiamateActions         |
    CallHistoryMethodAction

export const loadMatricole = (
    tipologia: TipoIntervento, 
    search?: string
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();
    const refreshCache: boolean = state.chiamate.destinatariMatricole.refreshCache;    
    const searchString = search || '';

    chiamateApi.getDestinatariMatricole(state, tipologia, searchString, refreshCache)
        .then(result => {
            dispatch({ type: 'chiamate/LOAD_DESTINATARI_MATRICOLE', value: result });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        })
}

export const loadTipiRichiesta = (
    matricola: Matricola, 
    tipologia: TipoIntervento
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
    
    const state: ApplicationState = getState();
    const refreshCache: boolean = state.chiamate.tipiRichiestaRiepiloghi.refreshCache;

    chiamateApi.getTipiRichiestaRiepilogoSpecifica(state, matricola.idSpecifica, tipologia, refreshCache)
        .then(result => {
            dispatch({ type: 'chiamate/LOAD_TIPI_RICHIESTA', value: result });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const loadChiamate = (
    search: string, 
    page: number, 
    tipoIntervento?: TipoIntervento, 
    stato?: StatoFiltroChiamate
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
    
    const state: ApplicationState = getState();
    const refreshCache: boolean = state.chiamate.chiamate.refreshCache;

    chiamateApi.getAllTickets(state, search, page, refreshCache, tipoIntervento, stato)
        .then(chiamate => {
            dispatch({ type: 'chiamte/LOAD_CHIAMATE', value: chiamate, page: page });

            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const saveTicket = (
    ticket: ChiamataNew
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
        
    const state = getState();

    chiamateApi.saveTicket(state, ticket)
        .then(_ => {
            dispatch({ type: 'chiamte/SAVE_TICKET_SUCCESS', value: ticket });
            dispatch({ type: 'core/END_AJAX_CALL' });

            notification.success('Segnalazione inviata con successo.', 'Invio completato');

            dispatch(push(routes.core.main + routes.chiamate.elenco));
        })
        .catch((error) => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}